// @ts-check

/** @file Defines the local TaskAssignedUser shell and associations. */

import TaskAssignedUserBase from "../model-bases/task-assigned-user.js"
import {PROJECT_REPLICA_DATABASE_IDENTIFIER, projectReplicaModel} from "../database/project-replica-contract.js"
import {PROJECT_REPLICA_SYNC_DECLARATION} from "../database/project-replica-sync.js"

/** Task-assignment row in the local application replica. */
const TaskAssignedUserModel = projectReplicaModel(TaskAssignedUserBase)

export default TaskAssignedUserModel

TaskAssignedUserModel.setDatabaseIdentifier(PROJECT_REPLICA_DATABASE_IDENTIFIER)
TaskAssignedUserModel.switchesTenantDatabase(PROJECT_REPLICA_DATABASE_IDENTIFIER)
TaskAssignedUserModel.sync = PROJECT_REPLICA_SYNC_DECLARATION
TaskAssignedUserModel.belongsTo("task")
